import styles from './NoPage.module.css';

const NoPage = () => {
  return (
  <div class={styles.centerFlex} role='main'>
    <h1>404</h1>
    <br></br>
    <p>This page does not exist.</p>
  </div>);
};

export default NoPage;
